module.exports = __webpack_public_path__ + "img/sponser-2.d0a2f925.png";